import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/about.css';

export default class About extends Component {
  render() {
    const features = [
      {
        icon: "fas fa-hotel",
        title: "1000+ Hotels",
        description:
          "Standardized stay experiences at unmatched prices across Kerala & Tamilnadu"
      },
      {
        icon: "fas fa-ship",
        title: "Houseboat Cruises",
        description:
          "Luxury houseboat experiences at Alleppey and Kumarakom backwaters"
      },
      {
        icon: "fas fa-car",
        title: "All Types of Vehicles",
        description:
          "From luxury cars to deluxe buses for all group sizes"
      },
      {
        icon: "fas fa-language",
        title: "Expert Guides",
        description:
          "Well-experienced Hindi & English speaking drivers who guide you throughout"
      },
      {
        icon: "fas fa-ticket-alt",
        title: "Ticketing Services",
        description:
          "Air ticketing, bus ticketing, and travel arrangements"
      },
      {
        icon: "fas fa-ring",
        title: "Tailor-Made Tours",
        description:
          "Customized packages according to guest needs and preferences"
      }
    ];

    const services = [
      "Hotel Reservations",
      "House Boat Reservations",
      "All Types of Vehicles",
      "Air Ticketing",
      "Bus Ticketing",
      "House Keeping Services",
      "Pilgrim Packages",
      "Family Group Tours",
      "Student Group Tours",
      "Domestic & International Holidays"
    ];

    return (
      <div className="about-page">

        {/* ==================== HERO SECTION ==================== */}
        <div className="about-hero">
          <div className="about-hero-overlay"></div>

          <div className="about-hero-content">
            <span className="about-hero-eyebrow">
              DISCOVER • EXPERIENCE • EXPLORE
            </span>

            <h1 className="about-hero-title">
              Welcome to Kairaly Hotels & Holidays
            </h1>

            <p className="about-hero-subtitle">
              Your trusted partner for unforgettable travel experiences
              in God's Own Country
            </p>

            <div className="about-hero-stats">
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-text">Years of Excellence</span>
              </div>

              <div className="stat">
                <span className="stat-number">5000+</span>
                <span className="stat-text">Happy Travelers</span>
              </div>

              <div className="stat">
                <span className="stat-number">1000+</span>
                <span className="stat-text">Hotel Partners</span>
              </div>
            </div>
          </div>
        </div>

        {/* ==================== COMPANY INTRODUCTION ==================== */}
        <section className="about-intro">
          <Grid>
            <Row className="intro-row">

              <Col xs={12} sm={6} className="intro-content">

                <span className="section-eyebrow">
                  ABOUT KAIRALY
                </span>

                <h2 className="section-title">
                  Traveling. Tours. Adventure.
                </h2>

                <div className="intro-text">
                  <p>
  As a Kerala Government accredited tour operator, we take pride in delivering 
  authentic, reliable and professionally managed travel experiences. Our 
  accreditation represents our commitment to quality, responsible tourism and 
  customer satisfaction. With our local expertise and personalized services, 
  we ensure that every guest experiences the beauty, culture and hospitality of 
  Kerala in the most memorable way.
</p>

                  <p>
                    We are one of the renowned tour operators in and around
                    Kerala, providing ready-made and fully customizable tour
                    packages designed to suit the needs of every traveler.
                    Our packages include sightseeing, trekking, houseboat
                    cruises, art and cultural experiences, pilgrim tours,
                    family holidays and much more.
                  </p>

                  <p>
                    At Kairaly Hotels & Holidays, trust is one of the most
                    important values that defines our relationship with our
                    guests. We believe that every journey should be comfortable,
                    memorable and hassle-free, which is why we provide
                    personalized assistance throughout your travel experience.
                  </p>

                  <p>
                    From the serene backwaters and misty hill stations to the
                    beautiful beaches and rich cultural heritage of Kerala,
                    our experienced team helps you discover the very best of
                    God's Own Country.
                  </p>

                </div>

                {/* ==================== ACCREDITATION BADGE ==================== */}
                <div className="kerala-accreditation">

                  <div className="accreditation-badge">

                    <div className="badge-icon">
                      <i className="fas fa-certificate"></i>
                    </div>

                    <div className="badge-content">
                      <span className="badge-label">
                        Government Accredited
                      </span>

                      <h3>
                        Kerala Tourism Accredited
                      </h3>

                      <p>
                        Recognized by the Kerala Tourism Department for
                        professional and reliable tourism services.
                      </p>
                    </div>

                  </div>

                </div>

              </Col>

              {/* ==================== INTRO IMAGE ==================== */}
              <Col xs={12} sm={6} className="intro-image">

                <div className="image-wrapper">

                  <img
                    src="/assets/img/travel1.jpeg"
                    alt="Beautiful Kerala travel experience"
                    className="about-image"
                  />

                  <div className="image-caption">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>Experience God's Own Country</span>
                  </div>

                </div>

              </Col>

            </Row>
          </Grid>
        </section>

        {/* ==================== FEATURES ==================== */}
        <section className="about-features1">

          <div className="container">

            <span className="section-eyebrow section-eyebrow-center">
              WHY KAIRALY
            </span>

            <h2 className="section-title-center">
              Why Choose Us?
            </h2>

            <p className="section-subtitle">
              What makes us your perfect travel partner
            </p>

            <Row className="features-grid">

              {features.map((feature, index) => (
                <Col
                  xs={12}
                  sm={6}
                  md={4}
                  key={index}
                  className="feature-col"
                >
                  <div className="feature-card">

                    <div className="feature-icon">
                      <i className={feature.icon}></i>
                    </div>

                    <h3 className="feature-title">
                      {feature.title}
                    </h3>

                    <p className="feature-description">
                      {feature.description}
                    </p>

                  </div>
                </Col>
              ))}

            </Row>

          </div>

        </section>

        {/* ==================== NETWORK & SERVICES ==================== */}
        <section className="about-network">

          <Grid>

            <Row>

              {/* NETWORK */}
              <Col xs={12} sm={6} className="network-content">

                <span className="section-eyebrow">
                  OUR NETWORK
                </span>

                <h2 className="section-title">
                  Our Network & Services
                </h2>

                <p className="network-text">
                  We are spread across Kerala & Tamilnadu with access to
                  1000+ hotels, offering standardized stay experiences at
                  unmatched prices. We take pride in introducing ourselves
                  as a leading and highly reputed inbound tour management
                  organization known for our quality of service and
                  customer satisfaction.
                </p>

                {/* VEHICLE FLEET */}
                <div className="vehicle-fleet">

                  <h3>
                    <i className="fas fa-bus"></i>
                    Our Vehicle Fleet
                  </h3>

                  <div className="vehicle-tags">

                    <span className="vehicle-tag">
                      Innova A/c
                    </span>

                    <span className="vehicle-tag">
                      Ertiga A/c
                    </span>

                    <span className="vehicle-tag">
                      Urbania Premium
                    </span>

                    <span className="vehicle-tag">
                      Swift Dezire
                    </span>

                    <span className="vehicle-tag">
                      Innova Crysta
                    </span>

                    <span className="vehicle-tag">
                      49 Seat Glider
                    </span>

                    <span className="vehicle-tag">
                      49 Seat Deluxe Bus
                    </span>

                    <span className="vehicle-tag">
                      36 Seat Deluxe Bus
                    </span>

                    <span className="vehicle-tag">
                      27 Seat Deluxe Bus
                    </span>

                    <span className="vehicle-tag">
                      26 Seat Traveler
                    </span>

                    <span className="vehicle-tag">
                      17 Seat Traveler
                    </span>

                    <span className="vehicle-tag">
                      14 Seat Traveler
                    </span>

                    <span className="vehicle-tag">
                      12 Seat Traveler
                    </span>

                  </div>

                </div>

              </Col>

              {/* SERVICES */}
              <Col xs={12} sm={6} className="services-list">

                <span className="section-eyebrow">
                  WHAT WE OFFER
                </span>

                <h2 className="section-title">
                  Our Services
                </h2>

                <div className="services-grid">

                  {services.map((service, index) => (
                    <div
                      key={index}
                      className="service-item"
                    >

                      <div className="service-check">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 6L9 17L4 12"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      <span>{service}</span>

                    </div>
                  ))}

                </div>

              </Col>

            </Row>

          </Grid>

        </section>

        {/* ==================== CALL TO ACTION ==================== */}
        <section className="about-cta">

          <div className="cta-content">

            <span className="cta-eyebrow">
              YOUR JOURNEY STARTS HERE
            </span>

            <h3>
              Ready to Explore Kerala?
            </h3>

            <p>
              Let us craft your perfect holiday experience
            </p>

            <a
              href="/contact"
              className="cta-button"
            >
              Plan Your Trip

              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 12H19M19 12L12 5M19 12L12 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

            </a>

          </div>

        </section>

      </div>
    );
  }
}